<script setup>
const props = defineProps({
  datetimeTo : String
})
</script>

<template>
  <div class="css__text-left">
    <h2>警告</h2>
    <p>重大な規約違反を確認したため、当サイトへのアクセスを一定期間制限いたします。</p>
    <p><strong>{{ props.datetimeTo }}</strong>まで当サイトを利用できません。</p>
    <p>今後、更なる規約違反行為を確認した場合は無期限のアクセス禁止処置をおこなう場合があります。</p>
  </div>
</template>

<style scoped>
  div {
    height: 70vh;
  }
</style>